import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { inputCls, Field, Panel, ActiveBadge, FormActions, errMsg } from "./ui";
import ServersPanel from "./ServersPanel";
import MonogramTile from "../MonogramTile";
import DeleteButton from "./DeleteButton";

const GOODS = [["mail", "Mail / Surat"], ["trade", "Trade"], ["auction", "Auction House"]];
const EMPTY = { name: "", slug: "", active: true, delivery_methods: ["mail", "trade", "auction"] };
const slugify = (s) => s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export default function GamesTab() {
  const [games, setGames] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/games").then((r) => setGames(r.data));
  useEffect(() => { load(); }, []);

  const reset = () => { setForm(EMPTY); setEditId(null); };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.delivery_methods.length) { toast.error("Pilih minimal satu metode pengiriman"); return; }
    setSaving(true);
    try {
      if (editId) await api.patch(`/games/${editId}`, form);
      else await api.post("/games", form);
      toast.success(editId ? "Game diperbarui" : "Game ditambahkan");
      reset(); load();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  const edit = (g) => { setEditId(g.id); setForm({ name: g.name, slug: g.slug, active: g.active, delivery_methods: g.delivery_methods || ["mail", "trade", "auction"] }); };
  const toggleMethod = (m) => setForm((f) => ({ ...f, delivery_methods: f.delivery_methods.includes(m) ? f.delivery_methods.filter((x) => x !== m) : [...f.delivery_methods, m] }));

  return (
    <>
      <Panel title={editId ? "Ubah Game" : "Tambah Game"} testId="games-form-panel">
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Field label="Nama">
            <input data-testid="game-name-input" required className={inputCls} value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value, slug: editId ? form.slug : slugify(e.target.value) })} />
          </Field>
          <Field label="Slug">
            <input data-testid="game-slug-input" required className={inputCls} value={form.slug} onChange={(e) => setForm({ ...form, slug: slugify(e.target.value) })} />
          </Field>
          <label className="flex items-center gap-2 text-sm text-[#F5F3ED] mt-7">
            <input data-testid="game-active-checkbox" type="checkbox" className="accent-[#D4AF37]" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} />
            Aktif (tampil di marketplace)
          </label>
          <FormActions editing={!!editId} onCancel={reset} saving={saving} testPrefix="game" />
          <div className="md:col-span-4">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">Metode pengiriman yang didukung (item & koin)</span>
            <div className="mt-2 flex flex-wrap gap-6">
              {GOODS.map(([k, label]) => (
                <label key={k} className="flex items-center gap-2 text-sm text-[#F5F3ED]">
                  <input data-testid={`game-delivery-${k}`} type="checkbox" className="accent-[#D4AF37]" checked={form.delivery_methods.includes(k)} onChange={() => toggleMethod(k)} /> {label}
                </label>
              ))}
            </div>
          </div>
        </form>
      </Panel>

      <Panel title="Daftar Game" testId="games-list-panel">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-widest text-[#A8A8AD] border-b border-[#35353B]">
            <th className="py-2">Foto</th><th className="py-2">Nama</th><th className="py-2">Slug</th><th className="py-2">Status</th><th className="py-2 text-right">Aksi</th>
          </tr></thead>
          <tbody>
            {games.map((g) => (
              <tr key={g.id} data-testid={`game-row-${g.slug}`} className="border-b border-[#35353B]">
                <td className="py-3"><MonogramTile name={g.name} className="w-16 h-10 rounded-sm" textSize="text-xs" testId={`game-thumb-${g.slug}`} /></td>
                <td className="py-3 text-[#F5F3ED]">{g.name}</td>
                <td className="py-3 font-mono text-xs text-[#A8A8AD]">{g.slug}</td>
                <td className="py-3"><ActiveBadge active={g.active} /></td>
                <td className="py-3 text-right"><button data-testid={`edit-game-${g.slug}`} onClick={() => edit(g)} className="text-[#D4AF37] hover:underline text-xs">Ubah</button>
                  <DeleteButton endpoint={`/games/${g.id}`} name={g.name} testId={`delete-game-${g.slug}`}
                    note="Game hanya bisa dihapus jika sudah tidak punya produk." onDone={() => { if (editId === g.id) reset(); load(); }} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>

      <ServersPanel games={games} />
    </>
  );
}
